import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  PM_SITIES,
  PM_CHECKLIST_QUES,
  GET_MONTHS,
  DOWNLOAD_PM_LIST,
  VIEW_PM_REPORT,
  PM_SITIES_FILTER,
  PM_SOFTWARE_AMSWER,
  PM_SOFTWARE_MAINTENANCE_SITES,
  PM_SOFTWARE_UPDATE_SITE_ASSIGNEE,
  PM_SOFTWARE_VIEW_REPORT,
  PM_SOFTWARE_REPORT_APPROVED,
  PM_SOFTWARE_REPORT_REJECTED,
  PM_SOFTWARE_POST_MAIL,
  PM_SOFTWARE_PM_LIST_DOWNLOAD, PM_SOFTWARE_PM_FILTER,
} from './type';

export const fetchPmSities = (filterData = null, page = 1) => async (
  dispatch
) => {
  console.log(filterData);
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null ? `${Config.maintenance.fetchMaintenancePMSites}?page=${page}`: `${Config.maintenance.fetchMaintenancePMSites}?status=${filterData.status}&project_id=${filterData.project_id}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate||''}&toDate=${filterData.toDate||''}&city_id=${filterData.city_id}&commercial_type_id=${filterData.commercial_type_id||''}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SITIES,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchPmQues = (id, gateId, isPmSoftware = 0) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.pmChecklist}?site_id=${id}&gate_id=${gateId}&is_pm_software=${isPmSoftware}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_CHECKLIST_QUES,
      payload: data.response.data,
    });
    return true;
  }
};

export const postPmAnswer = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.postPmAnswer}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const fetchMonth = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchMaintenanceMonths}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_MONTHS,
      payload: data.response.data,
    });
    return true;
  }
};

export const downloadPMList = (id,year) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.downloadPMList}?month_id=${id}&year=${year}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: DOWNLOAD_PM_LIST,
      payload: data.response.data,
    });
    return data.response.data;
  }
};

export const uploadPmList = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.uploadPMList}`
  );
  if (res) {
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const postApprovePmSite = (id,remark) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.maintenance.approvePmSite}?schedule_id=${id}&remark=${remark}`
  );
  if (res) {
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const pmSiteViewReport = (id, gate_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.pmSiteViewReport}?schedule_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: VIEW_PM_REPORT,
      payload: data.response.data,
    });
    return data.response.data;
  }
};

export const postGenerateReport = (data) => async () => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.pmSiteReport}`
  );
  if (res) {
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};

export const pmSiteReportDownload = (data) => async () => {
  // console.log(data);
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.maintenance.pmSiteReportDownload}?schedule_id=${data}`
  );
  if (res) {
    if (res?.data?.response?.status === true) {
      return res.data;
    } else {
      return false;
    }
  }
};


export const getPmSitiesFilterDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.pmSitesFilters}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SITIES_FILTER,
      payload: data.response.data,
    });
    return true;
  }
};

// postRejectPmSite
export const postRejectPmSite = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.maintenance.rejectPmSite}?schedule_id=${id}`
  );
  if (res) {
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
  }
};


export const pmSoftwareAnswer = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.maintenance.pmSoftwareAnswer}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_AMSWER,
      payload: data.response.data,
    });
    return true;
  }
};

export const pmSoftwareMaintenanceSites = (page=1, status = 1, filterData = null) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      filterData === null ? `${Config.maintenance.pmSoftwareSites}?page=${page}&status=${status}`: `${Config.maintenance.pmSoftwareSites}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}&city_id=${filterData.city_id}&commercial_type_id=${filterData.commercial_type_id}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_MAINTENANCE_SITES,
      payload: data.response.data,
    });
    return true;
  }
};

export const pmSoftwareUpdateAssignee = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.maintenance.pmSoftwareUpdateAssignee}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_UPDATE_SITE_ASSIGNEE,
      payload: data.response.data,
    });
    return true;
  }
};

export const pmSoftwareViewReport = (scheduleId) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.maintenance.pmSoftwareViewReport}?schedule_id=${scheduleId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_VIEW_REPORT,
      payload: data.response.data,
    });
    return true;
  }
};

export const pmSoftwareReportApprove = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.maintenance.pmSoftwareApproved}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_REPORT_APPROVED,
      payload: data.response,
    });
    return data.response;
  }
};

export const pmSoftwareReportRejected = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.maintenance.pmSoftwareRejected}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_REPORT_REJECTED,
      payload: data.response,

    });
    return data.response;
  }
};

export const pmSoftwarePostMail = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.maintenance.pmSoftwarePostMail}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_POST_MAIL,
      payload: data.response,
    });
    return data.response;
  }
};

export const PMSoftwareDownloadList = (id,year) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.maintenance.pmSoftwarePmDownload}?month_id=${id}&year=${year}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_PM_LIST_DOWNLOAD,
      payload: data.response.data,
    });
    return data.response.data;
  }
};

export const getPmSoftwareFilterDropDown = () => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.maintenance.pmSoftwareFilter}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_SOFTWARE_PM_FILTER,
      payload: data.response.data,
    });
    return true;
  }
};

